// extracted by mini-css-extract-plugin
export default {"statusRow":"QuizAnswersExportStatus_statusRow__cOYc2"};